import { File, FileImage, FileText } from 'lucide-react';

export default function IconsView({
  documents,
  selectedDocs,
  bulkMode,
  handleBulkSelect,
  handlePreview,
  handleDownload,
  canSignDocument,
  isPreviewable
}) {
  return (
    <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-4">
      {documents.map((doc) => (
        <div
          key={doc.id}
          className={`flex flex-col items-center p-3 rounded-lg hover:bg-gray-50/80 cursor-pointer transition-colors border border-transparent hover:border-slate-300 ${selectedDocs.has(doc.id) ? 'bg-blue-900/30 ring-2 ring-blue-500' : ''}`}
          onClick={() => bulkMode ? handleBulkSelect(doc.id) : (isPreviewable(doc.file_type) && handlePreview(doc))}
          onDoubleClick={() => handleDownload(doc)}
        >
          <div className={`w-14 h-14 rounded-lg flex items-center justify-center mb-2 ${
            doc.file_type?.toLowerCase() === 'pdf' ? 'bg-red-500/20 border border-red-500/30' : 
            ['jpg', 'jpeg', 'png', 'gif'].includes(doc.file_type?.toLowerCase()) ? 'bg-blue-500/20 border border-blue-500/30' : 'bg-gray-50 border border-slate-300'
          }`}>
            {doc.file_type?.toLowerCase() === 'pdf' ? (
              <File className="w-8 h-8 text-red-400" />
            ) : ['jpg', 'jpeg', 'png', 'gif'].includes(doc.file_type?.toLowerCase()) ? (
              <FileImage className="w-8 h-8 text-blue-400" />
            ) : (
              <FileText className="w-8 h-8 text-slate-600" />
            )}
          </div>
          <p className="text-xs text-slate-700 text-center truncate w-full" title={doc.name}>
            {doc.name.length > 12 ? doc.name.substring(0, 12) + '...' : doc.name}
          </p>
          {canSignDocument(doc) && (
            <span className="mt-1 w-2 h-2 bg-amber-500 rounded-full animate-pulse" title="Signature Required" />
          )}
        </div>
      ))}
    </div>
  );
}
